<template>
  <div class="commissionRateCell fz-13">
      <div>
          <span class="mr-6">普通</span>
          <span>{{ row.commission_rate }}%</span>
      </div>
      <div>
          <span class="mr-6">团长</span>
          <span>{{ row.activity_commission_rate }}%</span>
      </div>
  </div>
</template>
<script>
import mixin from './mixin';
export default {
  mixins: [mixin]
}
</script>
